export default "__VITE_ASSET__CmhqbrCA__"